$(function () {
    const activeClass = 'solid';
    const inactiveClass = 'outlined';
    const outlinedStarClass = 'hero__save-icon-empty';
    const solidStarClass = 'hero__save-icon-filled';
    const solidStarClassEvent = 'btn--star-fill';
    const outlinedStarClassEvent = 'btn--star';
    const savedClass = 'saved';

    const sendActionToApi = (action, event, key, endpoint, step, button) => {
        event.preventDefault();
        const isUndo = button.classList.contains(activeClass) || button.classList.contains(savedClass) || button.classList.contains(solidStarClassEvent);
        const obj = {
            ContentMetaDataContentKey: key,
            UserAction: isUndo ? `Undo${action}` : action,
            ContentMetaDataWorkflowStep: step,
            ContentUID: localStorage.getItem('tasb_content_actions')
        };

        $.ajax({
            type: 'POST',
            url: endpoint + '/SaveUserAction',
            data: JSON.stringify(obj),
            contentType: 'application/json',
            success: data => {
                toggleState(data.data);
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error('Error toggling action state');
                console.error('Error occurred:', textStatus, errorThrown);
            },
            dataType: 'json'
        });
    }

    const toggleState = (data) => {

        if (!!$('.content-actions').length) {
            if (data.like === 'active') {
                $('.content-actions__button--like').addClass(activeClass).removeClass(inactiveClass);
            } else {
                $('.content-actions__button--like').addClass(inactiveClass).removeClass(activeClass);
            }

            if (data.dislike === 'active') {
                $('.content-actions__button--dislike').addClass(activeClass).removeClass(inactiveClass);
            } else {
                $('.content-actions__button--dislike').addClass(inactiveClass).removeClass(activeClass);
            }

            if (data.saved === 'active') {
                //hero__save-icon
                $('.hero__save-text').text('Saved')
                $('.hero__save-icon').addClass(solidStarClass).removeClass(outlinedStarClass);
                $('.hero__save').addClass(savedClass);
            } else {
                $('.hero__save-text').text('Save to Favorites');
                $('.hero__save-icon').addClass(outlinedStarClass).removeClass(solidStarClass);
                $('.hero__save').removeClass(savedClass);
            }
        }else if(!!$('.resource_hero').length){
            if (data.saved === 'active') {
                $('.hero__save-text').text('Saved')
                $('.hero__save-icon').addClass(solidStarClass).removeClass(outlinedStarClass);
                $('.hero__save').addClass(savedClass);
            } else {
                $('.hero__save-text').text('Save to Favorites');
                $('.hero__save-icon').addClass(outlinedStarClass).removeClass(solidStarClass);
                $('.hero__save').removeClass(savedClass);
            }

        }else{
            if (data.saved === 'active') {
                $('.event-details__cta.btn--star.btn').text('Saved')
                $('.event-details__cta.btn--star.btn').addClass(solidStarClassEvent).removeClass(outlinedStarClassEvent);
            } else {
                console.log('here');
                $('.event-details__cta.btn.btn--star-fill').text('Save to Favorites');
                $('.event-details__cta.btn.btn--star-fill').addClass(outlinedStarClassEvent).removeClass(solidStarClassEvent);
            }
        }       
    }
    const fetchInitialState = (key, step, endpoint) => {

        var contentUID = localStorage.getItem('tasb_content_actions');

        if (!contentUID) {
            contentUID = crypto.randomUUID();
            localStorage.setItem('tasb_content_actions', contentUID);
        }

        $.ajax({
            type: 'GET',
            url: endpoint + '/GetUserAction',
            data: { ContentMetaDataContentKey: key, workflowStep: step, contentUID: contentUID },
            success: data => {
                toggleState(data.data);
            },
            dataType: 'json'
        });
    }

    if (!!$('.content-actions').length) {
        const containerList = [...document.querySelectorAll('.content-actions')];
        containerList.forEach(container => {
            const shareTrigger = container.querySelector('button.content-actions__share-trigger');
            const sharePopup = container.querySelector('.content-actions__share-popup');
            let shareLinks;
            if (sharePopup) {
                shareLinks = [...sharePopup.querySelectorAll('a.content-actions__share-link')];
            }
            const contentKey = container.getAttribute('data-content-key');
            const workflowStep = container.getAttribute('data-workflow-step');
            const actionEndpoint = container.getAttribute('data-endpoint');
            const likeBtn = container.querySelector('.content-actions__react-option--like button.content-actions__react-trigger, .content-actions__button--like');
            const dislikeBtn = container.querySelector('.content-actions__react-option--dislike button.content-actions__react-trigger, .content-actions__button--dislike');
            const saveBtn = container.querySelector('button.content-actions__save-trigger');

            const togglePopup = open => {
                if (open) {
                    sharePopup.classList.add('is-active');
                    shareLinks[0].focus();
                } else {
                    sharePopup.classList.remove('is-active');
                    shareTrigger.focus();
                }
                sharePopup.setAttribute('aria-hidden', !open);
            };

            if (shareTrigger && sharePopup) {
                shareTrigger.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    togglePopup(!sharePopup.matches('.is-active'));
                });

                document.body.addEventListener('keydown', e => {
                    if (e.code === 'Escape' && sharePopup.matches('.is-active')) togglePopup(false);
                });

                shareLinks.forEach(link => {
                    link.addEventListener('blur', e => {
                        if (
                            !e.relatedTarget?.matches('button.content-actions__share-trigger') &&
                            !sharePopup.matches('*:focus-within') &&
                            sharePopup.matches('.is-active')
                        ) {
                            togglePopup(false);
                        }
                    });
                });
            }
            likeBtn.addEventListener('click', e => sendActionToApi('Like', e, contentKey, actionEndpoint, workflowStep, likeBtn));
            dislikeBtn.addEventListener('click', e => sendActionToApi('Dislike', e, contentKey, actionEndpoint, workflowStep, dislikeBtn));
            if (saveBtn) saveBtn.addEventListener('click', e => sendActionToApi('Save', e, contentKey, actionEndpoint, workflowStep, saveBtn));

            // Fetch the initial state for this content
            fetchInitialState(contentKey, workflowStep, actionEndpoint);
        });
    }

    if (!!$('.hero.hero--article').length) {
        const container = document.querySelector('.hero.hero--article');
        const actionEndpoint = container.getAttribute('data-endpoint');
        const contentKey = container.getAttribute('data-content-key');
        const workflowStep = container.getAttribute('data-workflow-step');
        const saveLink = container.querySelector('a.hero__save');

        if (saveLink?.attributes['data-logged-in']?.value === 'true') {
            if (saveLink && !!workflowStep && !!contentKey && !!actionEndpoint) {
                saveLink.addEventListener('click', e => sendActionToApi('Save', e, contentKey, actionEndpoint, workflowStep, saveLink));
            }
        }
    }

    if (!!$('.event-details__content').length) {
        const container = document.querySelector('.event-details__content');
        const actionEndpoint = container.getAttribute('data-endpoint');
        const contentKey = container.getAttribute('data-content-key');
        const workflowStep = container.getAttribute('data-workflow-step');
        const saveLink = container.querySelector('a.btn--star.event-details__cta.btn');

        if (saveLink?.attributes['data-logged-in']?.value === 'true') {
            if (saveLink && !!workflowStep && !!contentKey && !!actionEndpoint) {
                saveLink.addEventListener('click', e => sendActionToApi('Save', e, contentKey, actionEndpoint, workflowStep, saveLink));
            }
        }

        fetchInitialState(contentKey, workflowStep, actionEndpoint);
    }

    if(!!$('.resource_hero').length){
        const container = document.querySelector('.resource_hero');
        const actionEndpoint = container.getAttribute('data-endpoint');
        const contentKey = container.getAttribute('data-content-key');
        const workflowStep = container.getAttribute('data-workflow-step');
        const saveLink = container.querySelector('a.hero__save');
        
        if (saveLink?.attributes['data-logged-in']?.value === 'true') {
            if (saveLink && !!workflowStep && !!contentKey && !!actionEndpoint) {
                saveLink.addEventListener('click', e => sendActionToApi('Save', e, contentKey, actionEndpoint, workflowStep, saveLink));
            }
        }
        fetchInitialState(contentKey, workflowStep, actionEndpoint);
    }
});
